import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  TextField,
  Grid,
  CardHeader,
  Divider,
  Button,
  Fab,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import SaveIcon from '@material-ui/icons/Save';
import RTL from '../../../../components/RTL';
import province from './../../../province';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Loading, showSnackbar} from 'redux/Action';
import {useDispatch, useSelector} from 'react-redux';
import {axios} from './../../../../axios';
import {values} from 'underscore';
const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: 'auto',
    position: 'relative',
    overflow: 'unset',
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  imageButton: {
    position: 'absolute',
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  imageInput: {
    display: 'none',
  },
  divider: {
    opacity: '0.1',
    marginLeft: '25%',
    marginRight: '25%',
    width: '50%',
    alignItems: 'center',
    backgroundColor: '#273c75',
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));

const Form = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector((state) => state.isLoading);


  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const {data, id, edit, reloadFunc, onClose} = props;
  console.clear();
  console.log(data)
  const [city, setCity] = useState(edit?data[0].get_province?.name:'');

  const classes = useStyles();

  const [cities, setCities] = useState([]);
  const [error, setError] = React.useState({
    name: '',
    city_id: '',
  });
  const [value, setValue] = React.useState({
    name: edit?data[0].name:"",
    city_id: edit?data[0].get_province?.id:"",
  });
  let id_sel_edit = edit ? data[0].city_id : '';

  const Get_Data_Sel = async () => {
    try {
      const res = await axios.get(`companies/${id}`, {
        headers: headers,
      });

      setValue({
        ...value,
        name: res.data.data?.company?.name,
        city_id: res.data.data?.company?.city?.county_id,
      });
      setCity(res.data.data?.company?.city?.name);

      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  };

  const Get_Component = async () => {
    try {
      const res = await axios.get('province', {
        headers: headers,
      });


      setCities(res.data.province);

   

      // console.log(res.data.cities,"axx")
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, 'eeeeeeeee');
    }
  };

  useEffect(() => {
    Get_Component();
    dispatch(Loading());
  }, []);

  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;

    let name = e.target.name;
    setError({...error, [name]: ''});
    setValue({...value, [name]: e.target.value});


    // setValue({
    //   ...value,
    //   [event.target.name]: event.target.value,
    // });
  };

  const InsertDriver = async () => {
    try {
      const res = await axios.post('cities', {
        province_id:value.city_id,
        name:value.name,
      },{
        headers:headers
      });
      dispatch(showSnackbar(true, 'success', 'شهر جدید با موفقیت ثبت شد'));
      setValue({...value, name: '', city_id: ''});
      setCity('');
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, 'eeeeeeeee');
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {
          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }
  };

  const UpdateCompany = async () => {
    try {
      const res = await axios.post(
        `cities/${id}`,
        {
          name: value.name,
          province_id: value.city_id,
          _method: 'patch',
        },
        {
          headers: headers,
        }
      );
      dispatch(showSnackbar(true, 'success', 'عملیات با موفقیت بروزرسانی شد'));
      setValue({...value, name: '', city_id: ''});
      setCity('');
      reloadFunc();
      onClose();
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, 'eeeeeeeee');
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {
          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }
  };

  const sendBtn = () => {
    let va_keys = Object.keys(value);

    let obj_empty = {};
    va_keys.forEach((element) => {
     if (value[element] === '') {
        obj_empty[element] = 'این فیلد نمی تواند خالی باشد';
      }
    });

    setError(obj_empty);

    if (Object.keys(obj_empty).length == 0) {
      if (edit) {
        dispatch(Loading());
        UpdateCompany();
      } else {
        dispatch(Loading());
        InsertDriver();
      }
    } else {
      // alert(JSON.stringify(obj_empty))
    }
  };

  return (
    <RTL>
      {!isLoading ? (
        <>
          {edit ? (
            <Grid justify="center" container>
              <CardHeader title="ویرایش شهر " />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>
          ) : (
            <Grid justify="center" container>
              <CardHeader title="ثبت شهر جدید" />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>
          )}

          <Grid container justify="space-between">
            <Grid item xs={12} sm={5}>
            <Autocomplete
                id="CityId"
                noOptionsText="همچنین استانی وجود ندارد"
                options={cities}
                // groupBy={(option) => option.get_province?.name}

                getOptionLabel={(option) => option.name}
                onChange={(event, val) =>
                  val !== null
                    ? ` ${setValue({...value, city_id: val.id})} ${setCity(
                        val.name
                      )} ${setError({...error, city_id: ''})}`
                    : ''
                }
                value={{
                  name: ` ${city}`,
                }}
                // value={city}

                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="نام استان"
                    variant="outlined"
                    error={Boolean(error?.city_id)}
                    helperText={error?.city_id}
                  />
                )}
              />
            
            </Grid>
            <Grid item xs={12} sm={6}>
            <TextField
                className={classes.input}
                label="نام شهر جدید"
                variant="outlined"
                value={value.name}
                error={Boolean(error?.name)}
                helperText={error?.name}
                onChange={handleChange}
                name="name"
              />
            </Grid>
          </Grid>

          {edit ? (
            <div className={classes.wrapper}>
              <Button
                fullWidth
                className={(classes.input, classes.inputBtn)}
                variant="contained"
                color="secondary"
                disabled={isLoading}
                onClick={() => sendBtn()}
                size="large"
                startIcon={<SaveIcon className={classes.submitButtonIcon} />}
              >
                بروزرسانی شهر
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          ) : (
            <div className={classes.wrapper}>
              <Button
                fullWidth
                onClick={() => sendBtn()}
                className={(classes.input, classes.inputBtn)}
                variant="contained"
                disabled={isLoading}
                color="secondary"
                size="large"
                startIcon={<SaveIcon className={classes.submitButtonIcon} />}
              >
                ثبت شهر جدید
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          )}
        </>
      ) : (
        <div className={classes.wrapper} style={{padding: 40}}>
          {isLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      )}
    </RTL>
  );
};

export default Form;
